import { DEFAULT_FEATURE_FLAGS, type FeatureFlags } from '@ace-tracker/shared';
import { useSettings } from './settings';
import type { ViewMode } from './urlState';

const OPTIMIZER_FLAGS = ['rtk', 'headroom', 'graphify'] as const;

/** True when at least one optimizer is on — the Token Optimization overview needs one to summarise. */
export function anyOptimizerEnabled(flags: FeatureFlags): boolean {
  return OPTIMIZER_FLAGS.some((key) => flags[key]);
}

/**
 * Whether a view appears in the sidebar and may be opened. Executive, All
 * Tools, Data Health and Settings are never flagged; Token Optimization
 * follows its optimizers, and Spend, Efficiency and Sessions need a token-priced tool (Claude Code or Codex).
 */
export function isViewEnabled(view: ViewMode, flags: FeatureFlags): boolean {
  if (view === 'optimization') return anyOptimizerEnabled(flags);
  if (view === 'spend' || view === 'efficiency' || view === 'sessions') return flags['claude-code'] || flags.codex;
  if (view in flags) return flags[view as keyof FeatureFlags];
  return true;
}

/** Feature flags for the signed-in dashboard. All on until settings load, so nothing flickers away. */
export function useFeatureFlags(): { flags: FeatureFlags; loaded: boolean } {
  const { data } = useSettings();
  return { flags: data?.features ?? DEFAULT_FEATURE_FLAGS, loaded: data !== undefined };
}
